import { render, staticRenderFns } from "./LinkTopBarIcon.vue?vue&type=template&id=2d187f0c&"
import script from "./LinkTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./LinkTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports